import { useState } from 'react';

const SIZE_CLASSES = {
  sm: 'h-6',
  md: 'h-8',
  lg: 'h-10',
  xl: 'h-14',
};

export function Wordmark({ size = 'md', variant = 'default', className = '' }) {
  const [imgFailed, setImgFailed] = useState(false);
  const heightClass = SIZE_CLASSES[size] || SIZE_CLASSES.md;

  if (imgFailed) {
    const sparkColor = variant === 'white' ? 'text-white' : 'text-brand-ink';
    const sizeText = { sm: 'text-lg', md: 'text-2xl', lg: 'text-3xl', xl: 'text-4xl' }[size] || 'text-2xl';
    return (
      <span className={`inline-flex items-baseline font-extrabold tracking-tight ${sizeText} ${className}`}>
        <span className={sparkColor}>Spark</span>
        {variant === 'white' ? (
          <span className="text-brand-lime">nation</span>
        ) : (
          <span
            className="bg-gradient-to-r from-[var(--brand-primary)] to-[var(--brand-gradient-end)] bg-clip-text"
            style={{ color: 'transparent', WebkitBackgroundClip: 'text' }}
          >
            nation
          </span>
        )}
      </span>
    );
  }

  const src = variant === 'white' ? '/sparknation-logo-white.svg' : '/sparknation-logo.svg';

  return (
    <img
      src={src}
      alt="SparkNation"
      draggable={false}
      onError={() => setImgFailed(true)}
      className={`${heightClass} w-auto select-none ${className}`}
    />
  );
}
